import React from 'react'
import * as Yup from 'yup'
import SumScoredQuestionnaireFields from './SumScoredQuestionnaireFields'
import { createSumScoredQuestionnaireSchema } from './createSumScoredQuestionnaireSchema'

const OCIR_QUESTIONS = [
  {
    key: 'OCIR_QUESTION_1',
    label: 'I have saved up so many things that they get in the way',
  },
  {
    key: 'OCIR_QUESTION_2',
    label: 'I check things more often than necessary',
  },
  {
    key: 'OCIR_QUESTION_3',
    label: 'I get upset if objects are not arranged properly',
  },
  {
    key: 'OCIR_QUESTION_4',
    label: 'I feel compelled to count while I am doing things',
  },
  {
    key: 'OCIR_QUESTION_5',
    label: 'I find it difficult to touch an object when I know it has been touched by strangers or certain people',
  },
  {
    key: 'OCIR_QUESTION_6',
    label: 'I find it difficult to control my own thoughts',
  },
  {
    key: 'OCIR_QUESTION_7',
    label: 'I collect things I do not need',
  },
  {
    key: 'OCIR_QUESTION_8',
    label: 'I repeatedly check doors, windows, drawers, etc.',
  },
  {
    key: 'OCIR_QUESTION_9',
    label: 'I get upset if others change the way I have arranged things',
  },
  {
    key: 'OCIR_QUESTION_10',
    label: 'I feel I have to repeat certain numbers',
  },
  {
    key: 'OCIR_QUESTION_11',
    label: 'I sometimes have to wash or clean myself simply because I feel contaminated',
  },
  {
    key: 'OCIR_QUESTION_12',
    label: 'I am upset by unpleasant thoughts that come into my mind against my will',
  },
  {
    key: 'OCIR_QUESTION_13',
    label: 'I avoid throwing things away because I am afraid I might need them later',
  },
  {
    key: 'OCIR_QUESTION_14',
    label: 'I repeatedly check gas and water taps and light switches after turning them off',
  },
  {
    key: 'OCIR_QUESTION_15',
    label: 'I need things to be arranged in a particular order',
  },
  {
    key: 'OCIR_QUESTION_16',
    label: 'I feel that there are good and bad numbers',
  },
  {
    key: 'OCIR_QUESTION_17',
    label: 'I wash my hands more often and longer than necessary',
  },
  {
    key: 'OCIR_QUESTION_18',
    label: 'I frequently get nasty thoughts and have difficulty getting rid of them',
  },
  {
    key: 'OCIR_SCORE',
    label: 'Score',
  },
]

export const OCIR_SCHEMA = createSumScoredQuestionnaireSchema('OCIR', 18, 4)

export type OCIRSchema = Yup.InferType<typeof OCIR_SCHEMA>

const OCIRFields = () => <SumScoredQuestionnaireFields type="OCIR" questions={OCIR_QUESTIONS} />

export default OCIRFields
